import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { currentCompanyDateFormatSelector } from '@/domain/companies';
import { paymentInfoSelector, paymentInvoicesSelector, paymentMetaSelector } from '@/domain/payments';
import type { PaymentInfoRecord, PaymentInvoicesList, PaymentMeta } from '@/domain/payments/types';

import ConfirmPayDialogView from '@/pages/dokkaPay/pages/payment/components/PaymentFooter/components/ConfirmPayDialog/ConfirmPayDialogView';
import { buildConfirmPaySummary } from '@/pages/dokkaPay/pages/payment/components/PaymentFooter/components/ConfirmPayDialog/summary';

interface ConfirmPayDialogProps {
  onClose: () => void;
  /** Sends the payment; resolves on success, rejects on failure. */
  onConfirm: () => Promise<unknown>;
}

/** "Confirm & Pay" review of the payment open on the payment page. */
const ConfirmPayDialog: React.FC<ConfirmPayDialogProps> = ({ onClose, onConfirm }) => {
  const paymentInfo: PaymentInfoRecord = useSelector(paymentInfoSelector);
  const paymentInvoices: PaymentInvoicesList = useSelector(paymentInvoicesSelector);
  const paymentMeta: PaymentMeta = useSelector(paymentMetaSelector);
  const dateFormat: string | null = useSelector(currentCompanyDateFormatSelector);

  const summary = useMemo(
    () => buildConfirmPaySummary(paymentInfo, paymentInvoices.toArray(), paymentMeta.payFrom),
    [paymentInfo, paymentInvoices, paymentMeta.payFrom],
  );

  return <ConfirmPayDialogView summary={summary} dateFormat={dateFormat} onClose={onClose} onConfirm={onConfirm} />;
};

export default ConfirmPayDialog;
